import { createSlice } from '@reduxjs/toolkit';

const cloneRowsForStore = (rows = []) => {
    if (!Array.isArray(rows)) return [];

    return rows.map((row) => {
        if (!row || typeof row !== 'object') return row;

        try {
            if (typeof structuredClone === 'function') {
                return structuredClone(row);
            }

            return JSON.parse(JSON.stringify(row));
        } catch (error) {
            // Last-resort fallback keeps Redux state decoupled from AG Grid references.
            return { ...row };
        }
    });
};

const initialState = {
    selectedRows: [],   // the currently selected AG Grid rows
    gridId: null,       // optional: which grid the selection came from
};

export const gridSelectedRowsSlice = createSlice({
    name: 'gridSelectedRows',
    initialState,
    reducers: {
        setGridSelectedRows: (state, action) => {
            const payload = action.payload || {};
            state.selectedRows = cloneRowsForStore(payload.rows);
            state.gridId = payload.gridId ?? null;
        },
        clearGridSelectedRows: (state) => {
            state.selectedRows = [];
            state.gridId = null;
        },
    },
});

export const { setGridSelectedRows, clearGridSelectedRows } = gridSelectedRowsSlice.actions;

export default gridSelectedRowsSlice.reducer;
